import React, { useState } from "react";
import moment from "moment";

import { Images } from "../../config";

import { boxContainer, tooltip, tables } from "../../components";

const Finance = (props) => {
  const data = props?.uniData;

  const scholarships = data?.scholarships;

  const [pageNo, setPageNo] = useState(1);
  const [limit, setLimit] = useState(10);

  const handleChange = (pagination) => {
    setPageNo(pagination.current);
    setLimit(pagination.pageSize);
  };

  const studentLifeCosts = [
    {
      icon: Images.Unifinanceaccommodation,
      title: "Accommodation",
      subTitle: "ON CAMPUS",
      hovertitle:
        "Shows the estimated monthly cost for staying in on-campus accommodation provided by the university.",
      value: data?.finance?.onAccCost
        ? `USD ${data?.finance?.onAccCost}`
        : "NA",
    },
    {
      icon: Images.Unifinanceaccommodation,
      title: "Accommodation",
      subTitle: "OFF CAMPUS",
      hovertitle:
        "Shows the estimated monthly cost for renting accommodation off-campus.",
      value: data?.finance?.offAccCost
        ? `USD ${data?.finance?.offAccCost}`
        : "NA",
    },
    {
      icon: Images.Unifinancefood,
      title: "Food",
      hovertitle: "Shows the estimated monthly cost of food.",
      value: data?.finance?.foodCost ? `USD ${data?.finance?.foodCost}` : "NA",
    },
    {
      icon: Images.Unifinancetransport,
      title: "Transport",
      hovertitle: "Shows the estimated monthly cost for transportation.",
      value: data?.finance?.transportCost
        ? `USD ${data?.finance?.transportCost}`
        : "NA",
    },
    {
      icon: Images.Unifinanceentertainment,
      title: "Entertainment",
      hovertitle: "Shows the estimated monthly expenditure for entertainment.",
      value: data?.finance?.entertainmentCost
        ? `USD ${data?.finance?.entertainmentCost}`
        : "NA",
    },
  ];

  const scholarshipColumns = [
    {
      title: "#",
      dataIndex: "serial",
      key: "0",
      width: 50,
      render: (text, record, index) => (
        <div>{(pageNo - 1) * limit + index + 1}</div>
      ),
    },
    {
      title: "Scholarship",
      key: "1",
      width: 200,
      render: (text, record) => <div>{record?.title ?? "NA"}</div>,
    },
    {
      title: "Entry Type",
      key: "2",
      width: 100,
      render: (text, record) => <div>{record?.entryType ?? "NA"}</div>,
    },
    {
      title: "Award Type",
      key: "3",
      width: 100,
      render: (text, record) => <div>{record?.awardType ?? "NA"}</div>,
    },
    {
      title: "Tution Coverage",
      key: "4",
      width: 150,
      render: (text, record) => <div>{record?.tuitionCoverage ?? "NA"}</div>,
    },
    {
      title: "Accommodation Coverage",
      key: "5",
      width: 80,
      render: (text, record) => (
        <div>{record?.accommodationCoverage ?? "NA"}</div>
      ),
    },
    {
      title: "Application Deadline",
      key: "6",
      width: 100,
      render: (text, record) => (
        <div>
          {data?.appDeadline
            ? moment(data?.appDeadline).format("DD MMMM, YYYY")
            : "NA"}
        </div>
      ),
    },
    {
      title: "Academic Requirement",
      key: "6",
      width: 80,
      render: (text, record) =>
        record?.academicReq ? (
          <tooltip.WhiteTooltip text={record?.academicReq}>
            <div className="text-main">See More</div>
          </tooltip.WhiteTooltip>
        ) : (
          "NA"
        ),
    },
    {
      title: "Additional Requirement",
      key: "7",
      width: 80,
      render: (text, record) =>
        record?.additionalReq ? (
          <tooltip.WhiteTooltip text={record?.additionalReq}>
            <div className="text-main">See More</div>
          </tooltip.WhiteTooltip>
        ) : (
          "NA"
        ),
    },
  ];

  return (
    <div className="relative">
      <div className={`flex flex-col gap-2`}>
        <div className="flex flex-col gap-2">
          <div className="box-title">Student Life Costs</div>
          <boxContainer.LiteBoxContainer>
            <div className="flex justify-around items-center h-full">
              {studentLifeCosts?.map((item, index) => (
                <div
                  className="flex flex-col gap-2 items-center justify-center"
                  key={index}
                  title={item?.hovertitle}
                >
                  <img src={item?.icon} className="h-[3.75em] w-[3.75em]" />
                  <div className="box-content-title pb-2 border-b-[2px] border-b-gray-300 w-full text-center">
                    {item.title} <br />
                    <div className="text-[0.625em] text-main w-full text-center h-[0.75em]">
                      {item.subTitle}
                    </div>
                  </div>
                  <div className="box-content-value">{item.value}</div>
                </div>
              ))}
            </div>
          </boxContainer.LiteBoxContainer>
        </div>

        <div className="flex flex-col gap-2">
          <div className="box-title">Scholarships</div>
          <div className="w-[calc(100vw-20em)] overflow-x-auto max-w-full">
            <tables.DefaultTable
              columns={scholarshipColumns}
              data={scholarships}
              rowKey={(record) => record.id}
              onChange={handleChange}
              pagination={true}
              onRow={(record) => ({
                onClick: () => {
                  window.open(`${record?.link}`, "_blank");
                },
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Finance;
